import { Observable } from "rxjs";
import { appConfig } from '../../insaweb.config';

export module SharedMethodsModule {
    // ── NO DATA helper ──────────────────────────────────────────────────────
    // Set once by LocalizeService after translations load; falls back to 'NO DATA'.
    export let _noDataText: string = 'NO DATA';

    export function setNoDataText(text: string): void {
        if (text) { _noDataText = text; }
    }

    /** Returns a standard no-records HTML template using the current locale. */
    export function noDataTemplate(): string {
        return `<p class='center no-data-message'>${_noDataText}</p>`;
    }
    // ────────────────────────────────────────────────────────────────────────
    /* group by categories for portfolio accordion in home 
    component and return main element which corresponds to hierarchy JSON object
    of portfolios grouped data*/
    export function groupBy(dataArray, col, value) {
        let groupedData = [], o = {}, hierarchyJSON = [];
        dataArray.forEach(function (a) {
            if (!o[a[col]]) {
                o[a[col]] = {};
                o[a[col]][col] = a[col];
                o[a[col]][value] = 0;
                groupedData.push(o[a[col]]);
            }
            o[a[col]][value] += +a[value];
        });
        groupedData.forEach(gr => {
            let mainElement = { Name: "", Amount: 0, SubItems: [] };
            mainElement.Name = gr.Element;
            mainElement.Amount = gr.Amount;

            let SubItems = [];
            dataArray.forEach(d => {
                if (gr.Element === d.Element) {
                    SubItems.push({ Name: d.SubElement, Amount: d.Amount });
                }
            });
            mainElement.SubItems = SubItems;
            hierarchyJSON.push(mainElement);
        });
        return hierarchyJSON;
    };

    function animateOnValueChange(selector, time, notification) {
        jQuery(selector).fadeIn(500);
        $(selector).html('<div class="alert alert-danger">' + notification.msg + '</div>');
        setTimeout(function () {
            jQuery(selector).fadeOut(1000);
        }, time, false);
    };

    export function addNotification(selector, message, success) {
        let notification = { cls: "", msg: "" };
        if (success === true) {
            notification.cls = "alert alert-success";
            notification.msg = message;
            animateOnValueChange(selector, 1500, notification);
        } else if (success === false) {
            notification.cls = "alert alert-danger";
            notification.msg = message;
            animateOnValueChange(selector, 2000, notification);
        };
        return notification;
    }


    export function loadGridGroupingAndSorting(GridName: string) {
        let grid: kendo.ui.Grid = $("#" + GridName).data("kendoGrid");

        switch (GridName) {
            case "TransactionsGrid":
                if (localStorage["transGridGrouping"] !== undefined && grid !== undefined) grid.dataSource.group(JSON.parse(localStorage["transGridGrouping"]));
                if (localStorage["transGridSorting"] !== undefined) grid.dataSource.sort(JSON.parse(localStorage["transGridSorting"]));
                break;
            case "PortfolioGrid":
                if (localStorage["portfolioGridGrouping"] !== undefined && grid !== undefined) {
                    const grouping = JSON.parse(localStorage["portfolioGridGrouping"])
                    const groupSettings = CustomizeGroupOrSortSettings(grid, grouping)
                    grid.dataSource.group(groupSettings);
                }
                if (localStorage["portfolioGridSorting"] !== undefined) {
                    const sorting = JSON.parse(localStorage["portfolioGridSorting"])
                    const sortSettings = CustomizeGroupOrSortSettings(grid, sorting)
                    grid.dataSource.sort(sortSettings);
                }
                break;
            case "InsaGrid":
                if (localStorage["insaGridGrouping"] !== undefined && grid !== undefined) grid.dataSource.group(JSON.parse(localStorage["insaGridGrouping"]));
                if (localStorage["insaGridSorting"] !== undefined && grid !== undefined) grid.dataSource.sort(JSON.parse(localStorage["insaGridSorting"]));
                break;
            default:
                break;
        }
    }

    // checks the grid to see whether there's a custom compare function predefined for specified column and if so, adds it to the settings argument
    export function CustomizeGroupOrSortSettings(kendoGrid: any, settings: kendo.ui.GridColumn[] | kendo.ui.GridColumn) {
        if (Array.isArray(settings)) {
            return settings.map(gs => customizeSingleGroupOrSortSetting(kendoGrid, gs))
        } else {
            return customizeSingleGroupOrSortSetting(kendoGrid, settings)
        }
    }

    function customizeSingleGroupOrSortSetting(kendoGrid: kendo.ui.Grid, settings: any) {
        const customCompareFunction = getCustomCompareFunctionIfExists(kendoGrid, settings.field);
        let result: any = {};
        result = settings;
        if (customCompareFunction) {
            result.compare = customCompareFunction
        }
        return result
    }

    function getCustomCompareFunctionIfExists(kendoGrid: kendo.ui.Grid, fieldName: string) {
        const field: any = kendoGrid.columns.find(col => col.field === fieldName)
        if (field) {
            if (field.groupable && field.groupable.sort && field.groupable.sort.compare) {
                return field.groupable.sort.compare
            } else if (field.sortable && field.sortable.compare) {
                return field.sortable.compare
            } else {
                return
            }
        }
        return
    }

    export function makeCustomCompareFunction(propName: string) {
        return (a, b) => {
            if (a.items) {
                a = a.items[0]
                b = b.items[0]
            }
            const aValue = typeof a[propName] === 'string' ? a[propName].toUpperCase() : a[propName];
            const bValue = typeof b[propName] === 'string' ? b[propName].toUpperCase() : b[propName];
            if (aValue == bValue) {
                return 0
            }
            else {
                return aValue < bValue ? -1 : 1;
            }
        }
    }

    export function saveGridOptions(kendoGrid: kendo.ui.Grid, gridName, dataName?) {
        let options: kendo.ui.GridOptions = kendoGrid.getOptions();
        options.dataSource = { sort: options.dataSource.sort, group: options.dataSource.group }
        localStorage["kendo " + gridName + (dataName ? `/${dataName}` : '') + " options"] = kendo.stringify(options);
        //save application version information
        localStorage[gridName + (dataName ? `/${dataName}` : '') + "_VerisonInfo"] = appConfig.version;
    }

    export function getSavedGridOptions(columnDefs, gridName, dataName?) {

        let gridOptions = localStorage["kendo " + gridName + (dataName ? `/${dataName}` : '') + " options"];
        let version: number = parseFloat(localStorage[gridName + (dataName ? `/${dataName}` : '') + "_VerisonInfo"]);
        if (!gridOptions) {
            return null;
        }
        if (version !== appConfig.version) {
            return null;
        }

        gridOptions = JSON.parse(gridOptions)

        // add custom compare functions if necessary
        if (gridOptions.dataSource && gridOptions.dataSource.sort) {
            gridOptions.dataSource.sort = CustomizeGroupOrSortSettings({ columns: columnDefs }, gridOptions.dataSource.sort)
        }
        if (gridOptions.dataSource && gridOptions.dataSource.group) {
            gridOptions.dataSource.group = CustomizeGroupOrSortSettings({ columns: columnDefs }, gridOptions.dataSource.group)
        }

        return gridOptions
    }

    export function clearGridOptions(gridName, dataName) {
        localStorage.removeItem("kendo " + gridName + (dataName ? `/${dataName}` : '') + " options");
        localStorage.removeItem(gridName + (dataName ? `/${dataName}` : '') + "_VerisonInfo");
    }

    export function mergeColumns(initialColumns, newColumns) {
        return newColumns.map(nc => {
            const ic = initialColumns.find(ic => ic.field === nc.field);
            return {
                ...nc,
                command: ic.command,
                values: ic.values
            }
        })
    }

    export function combineGridInitOptions(savedOptions, defaultOptions) {

        if (!savedOptions) {
            return defaultOptions
        }

        let customCommands: kendo.ui.GridColumnCommandItem[] = new Array<kendo.ui.GridColumnCommandItem>();
        //retrieve all custom commands defined on the grid
        defaultOptions.columns.forEach((col) => {
            if (col.command != undefined) {
                col.command.forEach((comm) => {
                    if (comm.click !== undefined) {
                        customCommands.push(comm);
                    }
                });
            }
        });


        // COMBINE COLUMNS
        const commonColumns = savedOptions.columns.filter(col => {
            return defaultOptions.columns.find(c => c.field === col.field);
        });

        commonColumns.forEach((cCol) => {
            // -->> set the title to the current text (and not the one which was saved!)
            // assumption is that it has already been translated
            let dCol = defaultOptions.columns.find(dc => dc.field === cCol.field);
             if (dCol) {
                 cCol.title = dCol.title;

                 // Always use the live template / footerTemplate / groupFooterTemplate so that
                 // changes added after a user first saved their grid options (e.g. a new print
                 // button added to the SecName cell template) are reflected immediately, without
                 // requiring the user to clear localStorage manually.
                 if (dCol.template !== undefined) {
                     cCol.template = dCol.template;
                 }
                 if (dCol.footerTemplate !== undefined) {
                     cCol.footerTemplate = dCol.footerTemplate;
                 }
                 if (dCol.groupFooterTemplate !== undefined) {
                     cCol.groupFooterTemplate = dCol.groupFooterTemplate;
                 }
             }
            // <<-- translation of title
            if (cCol.command != undefined) {
                cCol.command.forEach((command) => {
                    let savedCustomCommand: kendo.ui.GridColumnCommandItem = customCommands.find(c => c.name === command.name);
                    if (savedCustomCommand != null || savedCustomCommand != undefined) {
                        command.click = savedCustomCommand.click; // all this trouble, just to re-apply the click function callback, because kendo couldn't serialize it to JSON....
                    }
                });
            }

            cCol.groupable = dCol.groupable;

            cCol.sortable = dCol.sortable;
        });

        defaultOptions.columns = commonColumns;

        // COMBINE DATASOURCE
        defaultOptions.dataSource.options.sort = savedOptions.dataSource ? savedOptions.dataSource.sort : defaultOptions.dataSource.options.sort;
        defaultOptions.dataSource.options.group = savedOptions.dataSource ? savedOptions.dataSource.group : defaultOptions.dataSource.options.group;
        //     ...defaultOptions.dataSource,
        //     options: {
        //         ...defaultOptions.dataSource.options,
        //         // sort: savedOptions.dataSource ? savedOptions.dataSource.sort : defaultOptions.dataSource.options.sort,
        //         // group: savedOptions.dataSource ? savedOptions.dataSource.group : defaultOptions.dataSource.options.group,
        //     }
        // }

        return defaultOptions;
        // kendoGrid.setOptions(loadedOptions);
        // kendoGrid.refresh();
        // SharedMethodsModule.loadGridGroupingAndSorting(gridName);
    }

    export function runHandlerOnGridSortChange(gridOptions, handler) {
        gridOptions.sort = handler();
    }

    export function makeDefaultGridOptionChangeHandler(gridName, dataName) {
        return (evt) => {
            setTimeout(() => {
                const kendoGrid = $('#' + gridName).data('kendoGrid')
                SharedMethodsModule.saveGridOptions(kendoGrid, gridName, dataName)
            }, 50)
        }
    }

    export function makeGridOptionChangeHandler(gridName, dataName, existingFunction) {
        const defaultChangeHandler = makeDefaultGridOptionChangeHandler(gridName, dataName)
        if (existingFunction) {
            return (evt) => {
                existingFunction(evt);
                defaultChangeHandler(evt)
            }
        } else {
            return defaultChangeHandler
        }
    }

    export function saveGridOptionsOnChange(gridOptions: kendo.ui.GridOptions, gridName, dataName = null) {
        gridOptions.columnHide = makeGridOptionChangeHandler(gridName, dataName, gridOptions.columnHide)
        gridOptions.columnShow = makeGridOptionChangeHandler(gridName, dataName, gridOptions.columnShow)
        gridOptions.group = makeGridOptionChangeHandler(gridName, dataName, gridOptions.group)
        gridOptions.sort = makeGridOptionChangeHandler(gridName, dataName, gridOptions.sort)
        gridOptions.columnReorder = makeGridOptionChangeHandler(gridName, dataName, gridOptions.columnReorder)

    }


    /**
     * converts a file into base64 encoded string that can be sent as a string in json format
     */
    export function toBase64(file: Blob | File): Observable<string | ArrayBuffer> {
        return new Observable(observer => {
            const reader = new FileReader();
            reader.onload = () => observer.next(reader.result);
            reader.readAsDataURL(file);
        })
    }
}


// WEBPACK FOOTER //
// ./app/insa-custom-scripts/sharedMethods.ts